import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
function buildForm(params) {
    var _a, _b;
    const form = {
        type: 'form',
        children: [
            {
                type: 'form.image',
                description: 'Maximum allowed image size: 2 MB',
                label: params.label,
                key: 'image',
                preview: {
                    maxWidth: params.previewProps.maxWidth,
                    maxHeight: params.previewProps.maxHeight,
                    borderRadius: (_a = params.previewProps.borderRadius) !== null && _a !== void 0 ? _a : 100,
                },
                webcam: params.webcam,
                validate: {
                    required: true,
                    maxFileSize: (_b = params.allowedMaxSize) !== null && _b !== void 0 ? _b : 5 * 1024 * 1024,
                    allowedDimensions: params.allowedDimensions,
                },
            },
        ],
    };
    return form;
}
export function showImageUploadDialog(params) {
    showFormDialog({
        title: params.title,
        config: buildForm(params),
        onSubmit: (data) => {
            return fetch(data.image)
                .then((response) => response.blob())
                .then(params.onSave);
        },
    });
}
